export function StyleBlockFormatter (pEditor, pStyle)
{
  let blockFormattingItemsContainer = null,
      prevBlockFormatting,
      saveElementCurrentState = null;
  
  
  this.reInit = () =>
  {
    blockFormattingItemsContainer = null;
  };
  

  function getCurrentBlockFormat (styleIdList)
  {
    let blockFormatting = null,
        currentParentElement,
        currentParentElementName,
        currentSelection,
        currentRange,
        currentRangeStart;

    if (BEditor.browser.isIE && ((pEditor.pToolbar && pEditor.pToolbar.isMouseDown) || pEditor.isDropdownOpen) && prevBlockFormatting != null)
    {
      return prevBlockFormatting;
    }

    currentSelection = pEditor.range.selection.getCurrent();
    currentRange = pEditor.range.getCurrent();

    if (currentRange)
    {
      if (BEditor.browser.isIE)
      {
        if (currentSelection.type.toUpperCase() === 'CONTROL')
        {
          currentParentElement = currentRange.item(0);
        }
        else
        {
          currentRangeStart = currentRange.duplicate();
          currentRangeStart.collapse(true);
          currentParentElement = pEditor.helpers.element.getCurrentParentElement(currentRangeStart);
        }
      }
      else
      {
        currentParentElement = pEditor.helpers.element.getCurrentParentElement(currentRange);
      }

      currentParentElementName = currentParentElement ? currentParentElement.nodeName.toUpperCase() : '';

      while (currentParentElement && currentParentElementName !== 'BODY')
      {
        if (currentParentElementName + '|' + currentParentElement.className in styleIdList)
        {
          blockFormatting = styleIdList[currentParentElementName + '|' + currentParentElement.className];
        }

        currentParentElement = currentParentElement.parentNode;
        currentParentElementName = currentParentElement ? currentParentElement.nodeName.toUpperCase() : '';
      }
    }

    prevBlockFormatting = blockFormatting;
    return blockFormatting;
  }
  
  
  this.openBlockFormattingDropdown = (pButton) =>
  {
    let i,
        n,
        ind,
        elements,
        styleRules = BEditor.formattingStyleRules,
        itemsStyles = [],
        buttonName = pButton.getAttribute('name');

    pEditor.pDropdown = pButton.getDropdown();

    if (!pEditor.pDropdown)
    {
      return false;
    }

    if (pEditor.pDropdown.getState())
    {
      pEditor.closeDropdown(pButton);
    }
    else
    {
      if (BEditor.Dropdowns[buttonName].htmlForEditor)
      {
        if (!blockFormattingItemsContainer)
        {
          blockFormattingItemsContainer = pEditor.iFrameDoc.createElement('DIV');
          blockFormattingItemsContainer.setAttribute('style', 'position: absolute; left: -3700px; top: -3700px; z-index: 3; width: 300px; height: 300px; overflow: hidden; visibility: hidden;');
          blockFormattingItemsContainer.innerHTML = BEditor.Dropdowns[buttonName].htmlForEditor;
        }

        pEditor.iFrameDoc.body.insertBefore(blockFormattingItemsContainer, pEditor.iFrameDoc.body.firstChild);
        elements = blockFormattingItemsContainer.querySelectorAll('[data-wablockformattingitemindex]');

        for (i = 0; i < elements.length; i++)
        {
          ind = parseInt(elements[i].getAttribute('data-wablockformattingitemindex'));

          if (!isNaN(ind))
          {
            itemsStyles[ind] = {};

            for (n = 0; n < styleRules.length; n++)
            {
              itemsStyles[ind][styleRules[n]] = BEditor.styleHelpers.getElementStyle(elements[i], styleRules[n]);
            }
          }
        }

        blockFormattingItemsContainer = blockFormattingItemsContainer.parentNode.removeChild(blockFormattingItemsContainer);
      }

      pEditor.pDropdown.setReturnedParameters('itemsStyles', itemsStyles);
      pEditor.pDropdown.setReturnedParameters('selectedStyleId', getCurrentBlockFormat(pButton.getAttribute('parameters').styleIdList));
      pEditor.pDropdown.setReturnedParameters('isEditEmail', (window.EditorToolbarComposeEmailConfig && pEditor.pToolbarConfig.name === EditorToolbarComposeEmailConfig.name)); //TODO:Dime Kostyl for start email templates
      pEditor.openDropdown(pButton, pEditor.pDropdown, 'blockFormatting');
    }
  };

  
  function blockFormatting(pButton)
  {
    let selectedStyleId,
        pParameters,
        styleIdList,
        styleList,
        currentStyleBlock,
        currentRange, currentSelection,
        startParentBlockElement,
        endParentBlockElement,
        isSet = false,
        liFirstElement;

    pEditor.pDropdown = pButton.getDropdown();

    if (pEditor.pDropdown)
    {
      pParameters = pEditor.pDropdown.getReturnedParameters();
    }

    if (pParameters && pParameters.selectedStyleId)
    {
      selectedStyleId = pParameters.selectedStyleId;
    }

    saveElementCurrentState = null;

    pEditor.closeDropdown(pButton);

    if (selectedStyleId)
    {
      pEditor.range.stopCheckSelection();

      styleIdList = pButton.getAttribute('parameters').styleIdList;
      styleList = pButton.getAttribute('parameters').styles;
      currentStyleBlock = styleList[styleIdList[selectedStyleId]];
      currentRange = pEditor.range.getCurrent(true);
      currentSelection = pEditor.range.selection.getCurrent(true);

      if (currentRange)
      {
        startParentBlockElement = pEditor.layer.helpers.isRangeElementPositionAbsolute();

        if (startParentBlockElement)
        {
          startParentBlockElement.innerHTML = '<div>' + startParentBlockElement.innerHTML + '</div>';
          currentSelection.removeAllRanges();
          currentRange = pEditor.iFrameDoc.createRange();
          currentRange.selectNodeContents(startParentBlockElement);
          currentSelection.addRange(currentRange);
        }

        if (BEditor.browser.isWebKit)
        {
          let trueBlockTags = /^(?:P|H[1-6])$/i;

          currentRange = pEditor.range.getCurrent(true);
          startParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.startContainer, pEditor.checkAllBlockTags);
          endParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, pEditor.checkAllBlockTags);

          if (startParentBlockElement || endParentBlockElement)
          {
            if ((startParentBlockElement && startParentBlockElement.nodeName === 'LI') || (endParentBlockElement && endParentBlockElement.nodeName === 'LI'))
            {
              startParentBlockElement.innerHTML = '<' + currentStyleBlock['tag'] + '>' + startParentBlockElement.innerHTML + '</' + currentStyleBlock['tag'] + '>';
              liFirstElement = startParentBlockElement.querySelector(currentStyleBlock['tag']);

              if (liFirstElement)
              {
                pEditor.range.setCursorPoint(liFirstElement, false);
              }

              isSet = true;
            }
            else
            {
              currentSelection.removeAllRanges();

              if (startParentBlockElement && trueBlockTags.test(startParentBlockElement.nodeName))
              {
                currentRange.setStartBefore(startParentBlockElement);
              }

              if (endParentBlockElement && trueBlockTags.test(endParentBlockElement.nodeName))
              {
                currentRange.setEndAfter(endParentBlockElement);
              }

              currentSelection.addRange(currentRange);
            }
          }
        }

        if (!isSet)
        {
          pEditor.iFrameDoc.execCommand('FormatBlock', false, '<' + currentStyleBlock['tag'] + '>');
        }

        currentRange = pEditor.range.getCurrent(true);
        let nodeList = pEditor.helpers.element.getElementsInRangeByTagsNames(currentRange, new RegExp(currentStyleBlock['tag'], 'i'));

        nodeList.forEach(node =>
        {
          if (currentStyleBlock['cssClass'])
          {
            node.setAttribute('class', currentStyleBlock['cssClass']);
          }
          else
          {
            node.removeAttribute('class');
          }

          removeMigrationAttributeInEmail(node);
        });
      }

      pEditor.range.restoreBookmark();
    }
  }


  function removeMigrationAttributeInEmail (node)
  {
    if (node.hasAttribute('style') && node.getAttribute('style').toLowerCase().indexOf('-wa-inliner'))
    {
      node.removeAttribute('style');
    }
  }
  
  
  this.getCurrentBlockFormat = getCurrentBlockFormat;
  this.blockFormatting = blockFormatting;
}